import { ShiftResource } from '~/generated';
import moment from 'moment';
import { Shift } from './shift';

export class ShiftCollection {
  shifts: Shift[];

  constructor(shifts: ShiftResource[] | undefined) {
    this.shifts = shifts?.map((shift) => new Shift(shift)) || [];
  }

  public getShiftsWithTurnsOrderdByDate(): Shift[] | undefined {
    return this.shifts
      .filter((shift) => (shift.turns?.length || 0) > 0)
      .sort((a, b) => moment(a.startDate).diff(moment(b.startDate)));
  }

  public getShiftById(id: number): Shift | undefined {
    return this.shifts.find((shift) => shift.id === id);
  }
}
